import React from 'react';
import PropTypes from 'prop-types';
import { Config, getCookie, getCustomerValues, setCustomerValues, getInputError, getFormErrors } from '@deporvillage/utils-library-component';
import Modal from '@deporvillage/modal-component';
import ForgotPassword from './ForgotPassword';
import Customer from './utils/customer';

import styles from './ForgotPasswordPopup.module.scss';

const ForgotPasswordPopup = ({ isOpen, onClose, onBack }) => {
    const [customerData, setCustomerData] = React.useState(setCustomerValues(Customer));
    const [forgotPasswordError, setForgotPasswordError] = React.useState(false);
    const [forgotPasswordSuccess, setForgotPasswordSuccess] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const { api, country } = React.useContext(Config);

    const handleOnModalClose = () => {
        onClose && onClose();
    };

    const handleOnBack = () => {
        onBack && onBack();
    };

    // istanbul ignore next
    const handleOnInputChange = (input, form) => {
        const validateInput = {
            ...form,
            [input.id]: {
                ...input,
                error: getInputError(input, form),
            },
        };
        setCustomerData(validateInput);
        setForgotPasswordError(false);
    };

    // istanbul ignore next
    const postCustomerForgotPassword = async (api, payload) => {
        const tokenMd5 = getCookie('token_md5');
        return fetch(`${api}/api/customer/forgotpassword`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                country: country.code,
                'dpv-session': getCookie('dpv-session'),
                ...(!tokenMd5 ? {} : { 'token-app': tokenMd5 }),
            },
            credentials: 'include',
            body: JSON.stringify(payload),
        })
            .then((ans) => ans)
            .catch((e) => console.log(e));
    };

    // istanbul ignore next
    const handleOnForgotPassword = async (form) => {
        const [result, hasErrors] = getFormErrors(form);
        if (hasErrors) {
            setCustomerData(result);
        } else {
            setLoading(true);
            const res = await postCustomerForgotPassword(api, getCustomerValues(customerData));
            if (res.status === 200) {
                setLoading(false);
                setForgotPasswordSuccess(true);
            } else {
                setLoading(false);
                setForgotPasswordError(true);
            }
        }
    };

    return (
        isOpen && (
            <div
                className={`${styles['forgot-password-popup-component']} ${
                    !onClose ? styles['fixed-close'] : ''
                } ${!onBack ? styles['fixed-back'] : ''}`}
            >
                <Modal onClose={handleOnModalClose} onBack={handleOnBack}>
                    <div
                        className={`${styles['forgot-password-wrapper']} ${
                            loading ? styles['loading'] : ''
                        }`}
                    >
                        <ForgotPassword
                            customerData={customerData}
                            onChange={handleOnInputChange}
                            onForgotPassword={handleOnForgotPassword}
                            error={forgotPasswordError}
                            success={forgotPasswordSuccess}
                            onBack={handleOnBack}
                            showBackToLogin={!!onBack}
                        />
                    </div>
                </Modal>
            </div>
        )
    );
};

ForgotPasswordPopup.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onBack: PropTypes.func,
};

export default ForgotPasswordPopup;
